import { getApiClient } from './apiService'
import config from '../config/env'

const sendRequest = async data => {
  try {
    const response = await getApiClient().post('/requests', data)
    if (response.status === 201 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('sendRequest error: ', error)
    let errorMessage = error.message

    const responseMessage = error?.response?.data?.message
    if (responseMessage) {
      errorMessage = responseMessage
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const getRequests = async ({ page }) => {
  try {
    let url = `/requests?page=${page}`

    const response = await getApiClient().get(url)
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('getRequests error: ', error)
    let errorMessage = error.message

    const responseError = error.response.data?.message
    if (responseError) {
      errorMessage = responseError
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const getRequest = async ({ id }) => {
  try {
    let url = `/requests/${id}`

    const response = await getApiClient().get(url)
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('getRequests error: ', error)
    let errorMessage = error.message

    const responseError = error.response.data?.message
    if (responseError) {
      errorMessage = responseError
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const markAsCompleted = async ({ requestId }) => {
  try {
    const response = await getApiClient().post(
      `/requests/completed/${requestId}`,
    )
    if (response.status === 200) {
      return {
        isOk: true,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('markAsCompleted error: ', error)
    let errorMessage = error.message

    const responseMessage = error?.response?.data?.message
    if (responseMessage) {
      errorMessage = responseMessage
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

export const requestService = {
  sendRequest,
  getRequests,
  getRequest,
  markAsCompleted,
}
